// Utility to manage a per-session identifier stored in sessionStorage
export const SESSION_ID_STORAGE_KEY = 'app.session_id';

function generateUuid(): string {
  return globalThis.crypto.randomUUID();
}

export function initSessionId(): string {
  try {
    const existing = sessionStorage.getItem(SESSION_ID_STORAGE_KEY);
    if (existing) return existing;
    const sid = generateUuid();
    sessionStorage.setItem(SESSION_ID_STORAGE_KEY, sid);
    return sid;
  } catch {
    // If storage is unavailable (privacy mode), still return a generated id
    return generateUuid();
  }
}

export function getSessionId(): string {
  try {
    return sessionStorage.getItem(SESSION_ID_STORAGE_KEY) ?? initSessionId();
  } catch {
    return initSessionId();
  }
}
